/**
 * This component renders the content of the game centre based on the active tab
 * @param
 */
import React from 'react';

const Content = ({ activeTab, tabContents }) => {
  return (
    <>
      {tabContents[activeTab]}
    </>
  );
};

export default Content;